import styled from "styled-components";
import { Avatar, Button, IconButton, InputBase, List, ListItem, ListItemButton, ListItemText, Paper, Popover, Typography } from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import Menu from "@material-ui/icons/Menu";
import logo from "../logo.png";
import sdi from "../sdi.png";
import big from "../big.png";
import { Apps, MoreVert } from "@material-ui/icons";

import { useState } from 'react';
import {
    makeStyles,
} from '@material-ui/core/styles';
import Config from '../config.json';
import { useLocation } from 'react-router-dom';

const TopUpStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: 'red',
        "&.active": {
            backgroundColor: 'black',
        },
    },
    title: {
        fontSize: '12px',
    }
}));

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}


export default function TopMenu() {

    const classes = TopUpStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const open = Boolean(anchorEl);
    const open2 = Boolean(anchorEl2);
    const id = open ? 'simple-popover' : undefined;
    const id2 = open2 ? 'simple-popover2' : undefined;

    const location = useLocation();




    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        let btn = document.getElementById('app');
        btn.style.backgroundColor = '#ddd';
    };

    const handleClose = () => {
        setAnchorEl(null);
        let btn = document.getElementById('app');
        btn.style.backgroundColor = '';
    };

    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
        let btn = document.getElementById('help');
        btn.style.backgroundColor = '#ddd';

    };


    const handleClose2 = () => {
        setAnchorEl2(null);
        let btn = document.getElementById('help');
        btn.style.backgroundColor = '';
    };
    /* 
        <Logo>
            <img src={sdi} alt="logo satu data indonesia" width="75px" />
        </Logo>
    */

    return (
        <Container>
            <LeftTopMenu>
                <Logo>
                    <img src={big} alt="logo badan informasi geospasial" width="55px" />
                </Logo>
                <h3>Geoportal Badan Informasi Geospasial</h3>
            </LeftTopMenu>
            <TopSearch>
                {
                    /*
                    <Paper component="form" style={{ display: 'flex', width: '100%' }} >
                        <InputBase
                            placeholder="Search Dataset"
                            inputProps={{ 'aria-label': 'search dataset' }}
                            style={{ marginLeft: '10px', flex: 1 }}
                        />
                        <IconButton aria-label="search" style={{ padding: 10 }}>
                            <Search />
                        </IconButton>
                    </Paper>
                    */
                }
            </TopSearch>
            <RighTopMenu>
                <Button variant={location?.pathname === "/" ? 'outlined' : ''} style={{ marginRight: '10px', padding: "5px 15px", borderRadius: "20px"}} href="#/">
                    Beranda
                </Button>
                <Button variant={location?.pathname === "/katalog" ? 'outlined' : ''} style={{ marginRight: '10px', padding: "5px 15px", borderRadius: "20px"}} href="#/katalog">
                    Katalog
                </Button>
                <Button variant={location?.pathname === "/viewer" ? 'outlined' : ''} style={{ marginRight: '10px', padding: "5px 15px", borderRadius: "20px"}} href="#/viewer">
                    Peta
                </Button>
                <Button href={Config.api_domain+"/"}  style={{ marginRight: '10px', padding: "5px 15px", borderRadius: "20px"}}>
                    API
                </Button>
                {
                /*
                <Button variant={location?.pathname === "/tentang" ? 'contained' : 'outlined'} color="primary" style={{ marginRight: '10px'}} href="#/tentang">
                    Tentang
                </Button>
                */
                }
                <IconButton onClick={handleClick} id="app" >
                    <MoreVert />
                </IconButton>
                <Logo>
                    <img src={logo} alt="logo geospasial untuk negeri" width="145px" />
                </Logo>
                <Logo>
                    <img src={sdi} alt="logo satu data indonesia" width="75px" />
                </Logo>



                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    style={{ marginTop: '10px' }}
                >
                    <AppContainer>

                        <ListApp>
                            <ItemApp onClick={() => window.open('https://tanahair.indonesia.go.id')}>
                                <Avatar style={{ backgroundColor: '#df3344' }}>IG</Avatar>
                                <Typography className={classes.title}>Ina-Geoportal</Typography>
                            </ItemApp>

                            <ItemApp onClick={() => window.open('https://data.go.id')}>
                                <Avatar style={{ backgroundColor: '#a13402' }}>SDI</Avatar>
                                <Typography className={classes.title}>Portal SDI</Typography>
                            </ItemApp>
                            {
                                /*
                                  <ItemApp>
                                                <Avatar style={{ backgroundColor: '#c367eb' }}>KSP</Avatar>
                                                <Typography className={classes.title}>Portal KSP</Typography>
                                            </ItemApp>
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#5185f5' }}>D</Avatar>
                                                <Typography className={classes.title}>Demnas</Typography>
                                            </ItemApp>
                
                
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#f51414' }}>PK</Avatar>
                                                <Typography className={classes.title}>Peta Kita</Typography>
                                            </ItemApp>
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#00b5d9' }}>P</Avatar>
                                                <Typography className={classes.title}>Palapa</Typography>
                                            </ItemApp>
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#ebba67' }}>K</Avatar>
                                                <Typography className={classes.title}>KUGI</Typography>
                                            </ItemApp>
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#99bbbf' }}>SM</Avatar>
                                                <Typography className={classes.title}>SiMOJANG</Typography>
                                            </ItemApp>
                                            <ItemApp>
                                                <Avatar style={{ backgroundColor: '#327305' }}>IC</Avatar>
                                                <Typography className={classes.title}>Ina-CORS</Typography>
                                            </ItemApp>
                */
                            }
                        </ListApp>
                    </AppContainer>
                </Popover>
                {
                    /*
                    <IconButton onClick={handleClick2} id="help">
                        <Apps />
                    </IconButton>
                    <Popover
                        id={id2}
                        open={open2}
                        anchorEl={anchorEl2}
                        onClose={handleClose2}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        style={{ marginTop: '10px' }}
                    >
                        <HelpContainer>
                            <List component="nav" aria-label="secondary mailbox folders">
                                <ListItem button>
                                    <ListItemText primary="Help" />
                                </ListItem>
                                <ListItemLink href="#simple-list">
                                    <ListItemText primary="Knowledge Center" />
                                </ListItemLink>
                            </List>
                        </HelpContainer>
                    </Popover>
                    <IconButton size="small">
                        <Avatar />
                    </IconButton>
                    */
                }
            </RighTopMenu>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  padding: 3px;
  height: 8vh;
  background-color: white;
  border-bottom: 0.5vh solid #2A63B5;
  align-items: center;
`;


const LeftTopMenu = styled.div`
  display:flex;
  flex-grow:2;
  justify-content: flex-start;
  align-items: center;
`;

const Logo = styled.div`
  padding-left: 10px;
`;

const TopSearch = styled.div`
  flex-grow:1;
  display:flex;
  align-items: center;
`;

const RighTopMenu = styled.div`
  display:flex;
  padding-right: 10px;
  align-items: center;
`;

const AppContainer = styled.div`
    padding: 0px 10px 10px 10px;
    width: 200px;
`;

const ListApp = styled.ul`
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    justify-content: space-around;
`;

const ItemApp = styled.li`
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px;
    cursor: pointer;

    &:hover{
        background-color: #eee;
        /*box-shadow: 4px 4px 8px 0 rgba(0, 0, 255, 0.2)*/
    }
`;

const HelpContainer = styled.div`
    width: 200px;
`;
